<div class="row">
  <div class="col-lg-12">
    <app-system-loader [loader]="isLoading"></app-system-loader>
    <div class="ibox" *ngIf="!isLoading && show">
      <div class="ibox-title">
        <h5>
          <b>Última atualização: </b>
          <small *ngIf="atualizacoes.length > 0">{{ atualizacoes[0]?.user_cpf_name }} - {{ atualizacoes[0]?.dt_create }}</small>
          <small *ngIf="atualizacoes.length == 0"><i>sem atualizações</i></small>
        </h5>
        <div class="ibox-tools">
          <a (click)="visivel = !visivel">
            <i>Ver histórico de atualizações</i>&nbsp;&nbsp;
            <i class="fa fa-chevron-down" *ngIf="!visivel"></i>
            <i class="fa fa-chevron-up" *ngIf="visivel"></i>
          </a>
        </div>
      </div>
      <div class="ibox-content" *ngIf="visivel">
        <table *ngIf="atualizacoes.length > 0" class="table table-striped">
          <thead>
            <tr>
              <th>Usuário / Data</th>
              <th>Alterações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let atualizacao of atualizacoes">
              <td>
                {{ atualizacao.user_cpf_name }}
                <br>
                <i>{{ atualizacao.dt_create }}</i>
              </td>
              <td><ul [innerHTML]="atualizacao.summary"></ul></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
